module.exports = "/images/checkbox-multiselect.svg?de8cd8824fa2220a3d16abbce437d8a4";